import { z } from 'zod';

const researcherNotFoundErrorSchema = z.object({
  code: z.literal('USER_NOT_FOUND'), // Keep USER_NOT_FOUND for now to minimize backend changes, or change to RESEARCHER_NOT_FOUND if desired
  userId: z.string().optional(),
});
export type UserNotFound = z.infer<typeof researcherNotFoundErrorSchema>; // Changed ResearcherNotFound back to UserNotFound

const emailAlreadyExistsErrorSchema = z.object({
  code: z.literal('EMAIL_ALREADY_EXISTS'),
});
export type EmailAlreadyExists = z.infer<typeof emailAlreadyExistsErrorSchema>;

const auth0UserCreationFailedErrorSchema = z.object({
  code: z.literal('AUTH0_USER_CREATION_FAILED'),
});
export type Auth0UserCreationFailed = z.infer<
  typeof auth0UserCreationFailedErrorSchema
>;

const roleAssignmentFailedErrorSchema = z.object({
  code: z.literal('ROLE_ASSIGNMENT_FAILED'),
});
export type RoleAssignmentFailed = z.infer<
  typeof roleAssignmentFailedErrorSchema
>;

export const researcherError = z.union([
  researcherNotFoundErrorSchema,
  emailAlreadyExistsErrorSchema,
  auth0UserCreationFailedErrorSchema,
  roleAssignmentFailedErrorSchema,
]);
export type ResearcherError = z.infer<typeof researcherError>;
